import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=b1a8c3be&scoped=true&"
import script from "./manager.vue?vue&type=script&lang=js&"
export * from "./manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8c3be",
  null
  
)

export default component.exports